import React from 'react';
const Footer=()=>{
    return(
        <footer style={{backgroundColor:"black",color:"white",padding:"1rem",marginTop:"1rem"}}>
            <h2 style={{margin:"0"}}>All Right Reserved &copy; PAVANV88</h2>
        </footer>
    )
}
export default Footer;